import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { rem } from 'polished';
import VehicleDetailsHeadingInformationTemplate from './VehicleDetailsHeadingInformationTemplate';
export const VehicleDetailsHeadingInformationStyled = styled(VehicleDetailsHeadingInformationTemplate)`
    display: flex;
    justify-content: space-between;
    margin: ${rem(10)} ${rem(10)} 0 ${rem(10)};

    @media (max-width: ${breakpoints.sm}px) {
        flex-direction: column;
    }

    .delivery {
        padding: ${rem('1px')} ${rem('8px')} ${rem('1px')} ${rem('6px')};
        border-radius: ${rem('11px')};
        background: ${({ theme }) => theme.colors.grey6};
        font-size: ${rem('14px')};
        white-space: nowrap;
        height: fit-content;
        width: fit-content;
    }

    .information {
        @media (max-width: ${breakpoints.sm}px) {
            margin-bottom: ${rem('20px')};
        }

        .titleWithBenefits {
            margin-top: unset;

            .title {
                font-size: ${rem('22px')};
                text-transform: initial;
            }

            .specs .specs-title {
                font-size: ${rem('16px')};
                font-weight: normal;
            }

            .show-characteristics-button {
                .link {
                    font-size: ${rem('16px')};
                }

                .linkIcon {
                    margin-left: ${rem('7px')};
                }
            }
        }
    }
`;
